<template>
  <div class="content new-order form">
    <div class="row">
      <div class="col-sm-12 description-line">
        <div class="row description col-sm-12">
          <div class="col-sm-3">
            <span>Advertiser: </span
            ><label>{{ ContractSummary.advertiserName }}</label>
          </div>
          <div class="col-sm-3">
            <span>Product: </span
            ><label>{{ ContractSummary.productName }}</label>
          </div>
          <div class="col-sm-2">
            <span>Status: </span><label>{{ ContractSummary.status }}</label>
          </div>
          <div class="col-sm-2">
            <span>Create By: </span
            ><label>{{ ContractSummary.createByName }}</label>
          </div>
          <div class="col-sm-2">
            <span>Date: </span
            ><label>{{ formatter_datetime(ContractSummary.createDate) }}</label>
          </div>

          <div class="col-sm-3">
            <span>Contracting Party: </span
            ><label>{{ ContractSummary.contractParty }}</label>
          </div>
          <div class="col-sm-3">
            <span>Order No.: </span
            ><label>{{ ContractSummary.orderNumber }}</label>
          </div>
          <div class="col-sm-2">
            <span>Contract No.: </span>
            <label>{{ ContractSummary.contractNumber }}</label>
          </div>
          <div class="col-sm-2">
            <span>Updated By: </span
            ><label>{{ ContractSummary.updateByName }}</label>
          </div>
          <div class="col-sm-2">
            <span>Date: </span
            ><label>{{ formatter_datetime(ContractSummary.updateDate) }}</label>
            <el-button
              link
              style="font-size: 18px; padding-left: 5px"
              @click="RefreshDate"
              v-if="
                useContract.getContractFunctionPermission('RefreshDate')?.enable
              "
              :disabled="
                useContract.getContractFunctionPermission('RefreshDate')
                  ?.disable
              "
            >
              <el-icon>
                <refresh />
              </el-icon>
            </el-button>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <el-card>
        <el-tabs
          v-model="activeName"
          @tab-click="operationInstructionsTabClick"
          :beforeLeave="changeAction"
          @tab-change="changeTabAction"
        >
          <el-tab-pane label="Contract Info" name="ContractInfo">
            <contract-setting
              :disabled="useContract.disabled"
              :HasRevise="bHasRevise"
            ></contract-setting>
          </el-tab-pane>
          <el-tab-pane label="Media Items" name="MediaItems">
            <media-item
              :disabled="useContract.disabled"
              :BusinessUnit="BusinessUnit"
            ></media-item>
          </el-tab-pane>
          <el-tab-pane label="Internal Split" name="InternalSplit">
            <internal-split
              :disabled="useContract.disabled"
              ref="InternSplitRef"
            ></internal-split>
          </el-tab-pane>
          <!-- <el-tab-pane
            label="Operation Instructions"
            name="Operation"
            v-if="false"
          >
            <operation-instruction :disabled="OperationDisabled" />
          </el-tab-pane> -->
          <el-tab-pane label="Payment Schedule" name="Payment">
            <payment-schedule
              :ContractId="Id"
              :isLoading="isPaymentLoading"
              :disabled="useContract.disabled"
            >
            </payment-schedule>
          </el-tab-pane>
          <el-tab-pane label="Draft Contract" name="DraftContract">
            <draft-contract
              :disabled="useContract.disabled"
              ref="contractDraftRef"
              @changeMode="changeMode"
            ></draft-contract>
          </el-tab-pane>
          <el-tab-pane
            label="Additional Info"
            name="AdditionalInfo"
            v-if="useContract.AdditionalInformation?.enable"
          >
            <additional-vue
              :contract_id="useContract.cId"
              :additional_info="useContract.AdditionalInformation"
              v-if="activeName == 'AdditionalInfo'"
            />
          </el-tab-pane>
        </el-tabs>
      </el-card>
      <!-- Contract Buttons -->
      <div style="display: flex; justify-content: space-between; width: 100%">
        <div class="left">
          <base-button
            class="btn-urgent"
            v-if="
              useContract.getContractFunctionPermission('VoidContract')?.enable
            "
            :disabled="
              useContract.getContractFunctionPermission('VoidContract')?.disable
            "
            @click="toVoid"
            >Void</base-button
          >
          <base-button
            v-if="
              useContract.getContractFunctionPermission('CancelContract')
                ?.enable
            "
            :disabled="
              useContract.getContractFunctionPermission('CancelContract')
                ?.disable
            "
            @click="toCancel"
            class="btn-urgent"
            >Cancel
          </base-button>
          <base-button
            v-if="
              useContract.getContractFunctionPermission('ReviseUnlock')?.enable
            "
            class="btn-Void"
            :disabled="
              useContract.getContractFunctionPermission('ReviseUnlock')?.disable
            "
            @click="toReviseUnlock"
          >
            Revise Unlock
          </base-button>
        </div>
        <div style="display: flex; column-gap: 5px">
          <base-button
            type="primary"
            v-if="
              isEditButton &&
              useContract.getContractFunctionPermission('Edit')?.enable
            "
            @click="toEdit"
            :disabled="
              bEditDiabled ||
              useContract.getContractFunctionPermission('Edit')?.disable
            "
            >Edit</base-button
          >
          <base-button
            type="primary"
            v-if="isSubmitButton"
            @click="toSubmit"
            :disabled="bSubmitDisabled"
            >Submit</base-button
          >
          <base-button
            type="primary"
            v-if="isSubmitJobButton"
            :disabled="bSubmitJobDisabled"
            @click="toSubmitJob"
            >Submit</base-button
          >
          <base-button
            type="primary"
            v-if="
              useContract.getContractFunctionPermission(APPROVE_FUNCTION)
                ?.enable
            "
            @click="toApprove"
            :disabled="
              useContract.getContractFunctionPermission(APPROVE_FUNCTION)
                ?.disable
            "
            >Approve</base-button
          >
          <base-button
            type="secondary"
            v-if="isReviseButton"
            :disabled="bReviseDisabled"
            @click="toRevise"
            >Revise</base-button
          >
          <base-button type="primary" @click="toSave" v-if="isSaveButton"
            >Save
          </base-button>
          <base-button v-if="isBackButton" @click="HandlerClick('Back')">
            &lt; Back</base-button
          >
          <base-button type="primary" v-if="isNextButton" @click="toNext"
            >Next ></base-button
          >

          <base-button @click="HandlerClick('Close')">Close</base-button>
        </div>
      </div>
    </div>

    <div class="approve-dialog">
      <el-dialog title="Approve" v-model="ApproveDialog" :width="500">
        <div>Comment</div>
        <div>
          <el-input
            v-model="ApproveComment"
            :rows="2"
            placeholder="Comment"
            type="textarea"
          ></el-input>
        </div>
        <template #footer>
          <el-button type="primary" @click="ApproveContract('Accept')"
            >Approve</el-button
          >
          <el-button @click="ApproveContract('Reject')">Reject</el-button>
        </template>
      </el-dialog>
    </div>
  </div>
</template>

<script setup>
// components
import baseButton from '@/components/newUI/BaseButton';
import baseCheckbox from '@/components/newUI/Inputs/BaseCheckbox';
import baseInput from '@/components/newUI/Inputs/BaseInput';
import { ElButton, ElMessage, ElMessageBox } from 'element-plus';
import { Refresh } from '@element-plus/icons-vue';
import { nextTick, ref, reactive, h } from 'vue';

import ContractSetting from './ContractSetting';
import MediaItem from './MediaItem';
import InternalSplit from './InternalSplit';
import PaymentSchedule from './PaymentSchedule';
import OperationInstruction from './OperationInstruction';
import DraftContract from './DraftContract';
import AdditionalVue from './AdditionalInformation';

import { formatter_datetime } from '@/assets/js/formatter';
import contractnet from '@/network/contractnet';

// state
import { storeToRefs } from 'pinia';
import { useContractStore } from '@/store/contract';
import { useContractInfoStore } from '@/store/contractinfo';
import { useMediaItemsStore } from '@/store/mediaItem';
import { useOperationStore } from '@/store/operation';
import { useInternalSplitStore } from '@/store/internalsplit';
import { useContractDraftStore } from '@/store/contractDraft';
import { usePaymentScheduleStore } from '@/store/paymentSchedule';
import { useOrderStore } from '@/store/order.js';
import { useAuthorityStore } from '@/store/authority';

import router from '@/router';
import { useRoute } from 'vue-router';
import { routeParamsStore } from '@/store/routeParams';

var APPROVE_FUNCTION = 'ApproveContract';

const route = useRoute();
const useRouteParams = routeParamsStore();

const util = require('@/utilFunction');
const messageConfig = require('@/models/messageConfig.js');

const ActivingName = ref('');
const mode = ref(''); //当前页面mode状态
const VoidComment = ref('');

const changeMode = (value) => {
  mode.value = value;
  useContract.changeMode(mode.value);
};

// 加载Order Store
const useOrder = useOrderStore();
const useContract = useContractStore();
await useContract.Init();

const BusinessUnit = useContract.getBusinessUnit();

const InternSplitRef = ref(); // Split Ref

mode.value = useRouteParams.getPageMode();

const {
  ContractNumber,
  activeName,
  ContractSummary,
  Id,
  bHasRevise,
  // EnableEditMessage,
} = storeToRefs(useContract);

const useContractInfo = useContractInfoStore();
useContractInfo.$reset();
//await useContractInfo.RefreshContractInfo();

const useMediaItems = useMediaItemsStore();
useMediaItems.$reset();

const useOperation = useOperationStore();
const useInternalSplit = useInternalSplitStore();
useInternalSplit.$reset();

const useContractDraft = useContractDraftStore();
const { isUrgent } = storeToRefs(useContractDraft);
useContractDraft.$reset();

changeMode(useRouteParams.getPageMode());
// if (EnableEditMessage.value) {
//   changeMode('view');
// }
if (useContract.getContractFunctionPermission('Edit')?.disable) {
  changeMode('view');
}

// #endregion

var TabNames = [
  {
    name: 'ContractInfo',
    label: 'Contract Info',
    store: 'contractinfo',
    index: 0,
  },
  {
    name: 'MediaItems',
    label: 'Media Items',
    store: 'mediaItem',
    index: 1,
  },
  {
    name: 'InternalSplit',
    label: 'Insternal Split',
    store: 'internalsplit',
    index: 2,
  },
  // {
  //   name: 'Operation',
  //   index: 3,
  //   store: 'operation',
  // },
  {
    name: 'Payment',
    index: 3,
    store: 'paymentSchedule',
    label: 'Payment Schedule',
  },
  {
    name: 'DraftContract',
    index: 4,
    store: 'contractDraft',
    label: 'Draft Contract',
  },
  {
    name: 'AdditionalInfo',
    index: 5,
    store: '',
    label: 'Additional Info',
  },
];

const contractDraftRef = ref();
const bBeforeLeave = ref(true); // Tab切换前验证
const isVoidButton = ref(false);
const bVoidDisabled = ref(true);
const isBackButton = ref(false);
const isNextButton = ref(true);
const isEditButton = ref(true);
const bEditDiabled = ref(true);
const isSaveButton = ref(false);
const isSubmitButton = ref(false);
const isSubmitJobButton = ref(false);
const bSubmitDisabled = ref(true);
const bSubmitJobDisabled = ref(true);
const isApproveButton = ref(false);
const bApproveDisabled = ref(true);
const isReviseButton = ref(false);
const bReviseDisabled = ref(true);

const ApproveDialog = ref(false);
const ApproveComment = ref();

const OperationDisabled = ref(null); // 营运页面编辑状态
const isPaymentLoading = ref(false); // Payment 特殊加载处理

// 页面刷新前处理
window.onbeforeunload = () => {
  var key = useContract.cId;

  useRouteParams.setPageParam({
    key,
    mode: mode.value,
  });
};

// 审批
// const ApproveModel = reactive({
//   Unit: useContract.Unit.alias,
//   OrderId: useContract.getOrderId(),
// });

const isInternalSplitTab = () => {
  return activeName.value === 'InternalSplit';
};
const isMediaItemsTab = () => {
  return activeName.value === 'MediaItems';
};
const isOperationInstructionsTab = () => {
  return activeName.value === 'Operation';
};
// 刷新页面
const RefreshPage = async () => {
  await useContractInfo.RefreshContractInfo();

  router.push({
    query: {
      ContractNo: ContractNumber.value,
      cId: useContract.cId,
    },
  });
};

// 刷新数据
const RefreshData = async (index, isLoading) => {
  isLoading = isLoading || false;
  index = index || getActiveIndex(activeName.value);

  if (index >= getActiveIndex('ContractInfo')) {
    if (
      (useContractInfo.Contract.id || 0) === 0 ||
      (useContractInfo.ContractBooking.id || 0) === 0 ||
      isLoading
    ) {
      await useContractInfo.RefreshContractInfo();
    }
  }
  if (index == getActiveIndex('MediaItems')) {
    // 加载Media Options
    var Entity = useContractInfo.Contract.companyEntityCode
      .split(',')
      .filter((t) => t);
    await useMediaItems.getMediaList(
      useContractInfo.Contract.contractType,
      Entity?.[0]
    );

    useMediaItems.filterMediaOptions();

    useMediaItems.RefreshMediaItems();
  }
  if (index >= getActiveIndex('InternalSplit')) {
    if (
      index === getActiveIndex('InternalSplit') ||
      index === getActiveIndex('Operation')
    ) {
      if (useInternalSplit.ProductionCostOptions.length === 0) {
        await useInternalSplit.getProductionCostOptions();
      }
      if (useInternalSplit.SalesServiceTypeOptions.length === 0) {
        await useInternalSplit.getSalesServiceOptions();
      }
    }

    if (index === getActiveIndex('InternalSplit')) {
      await useInternalSplit.RefreshInternalSplit();
    }

    if ((useInternalSplit.ContractSplit.id || 0) === 0 && !isLoading) {
      useInternalSplit.ContractSplit.contractId = useContract.Id;

      useInternalSplit.Regenerate();
    }
  }
  if (index == getActiveIndex('Operation')) {
    // 更新营运状态
    if (OperationDisabled.value === null || useContract.Status === 'Open') {
      OperationDisabled.value = useContract.disabled;
    }

    if (useOperation.PostDateTypeOptions.length === 0) {
      useOperation.getPostDateTypeOptions();
    }
    if (useOperation.DepostDateTypeOptions.length === 0) {
      useOperation.getDepostDateTypeOptions();
    }

    await useOperation.RefreshOperation();
  }
  if (index === getActiveIndex('Payment')) {
    isPaymentLoading.value = true;
  }
  if (index == getActiveIndex('DraftContract')) {
    if (!contractDraftEnter()) {
      return;
    }

    // if (useContract.bEnableEdit) {
    //   await ChangeDraftContract();
    // }
    if (!useContract.getContractFunctionPermission('Eidt')?.disable) {
      await ChangeDraftContract();
    }
    await useContractDraft.RefreshContractDraft();
  }
};
const isReviseUnlock = () => {
  const useAuthority = useAuthorityStore();
  return (
    useAuthority.isOrderTop() &&
    getActiveIndex(activeName.value) === getActiveIndex('DraftContract')
  );
};

// 当前定位的Tab Index
const getActiveIndex = (TabName) => {
  var index = TabNames.find((t) => t.name === TabName)?.index;

  if (index === undefined) {
    index = -1;
  }
  return index;
};
const getTabName = (index) => {
  return TabNames[index].name;
};

// TabPane => BeforeLeave
const changeAction = async () => {
  await nextTick();

  const index = getActiveIndex(ActivingName.value);

  var bResult = true;
  if (bBeforeLeave.value) {
    if (isInternalSplitTab()) {
      bResult = InternSplitLeave();
      if (!bResult) {
        return false;
      }
    }

    //验证 是否可以进入Draft Contract
    bResult = await SaveEvent().then((res) => res);
    if (!bResult) {
      return false;
    }

    if ((route.query.ContractNo || '') === '') {
      bBeforeLeave.value = false;
      useContract.activeName = ActivingName.value;

      RefreshPage();
      return;
    }
  }

  bBeforeLeave.value = true; // 重置BeforeLeave设定
  ActivingName.value = '';

  // Draft Contract Action Enter
  if (index === getActiveIndex('DraftContract')) {
    if (!contractDraftEnter()) {
      return false;
    }
  }

  return bResult;
};

const changeTabAction = async (name, isLoading) => {
  // 更新Store的Page
  const index = getActiveIndex(activeName.value);
  await RefreshData(index, isLoading);

  // Payment 特殊处理
  isPaymentLoading.value = false;

  changeButtonStatus(index);
};
changeTabAction(undefined, true);

const operationInstructionsTabClick = async (e) => {
  ActivingName.value = e.props.name;

  await nextTick();
};

const RefreshDate = () => {
  contractnet.UpdateDate(useContract.cId).then((res) => {
    if (res.data?.message) {
      ElMessage({
        message: res.data.message,
        type: 'warning',
      });
      return;
    }

    ContractSummary.value.updateDate = res.data.updateDate;
  });
};

// #region Page Event
const toNext = async () => {
  var index = getActiveIndex(activeName.value);
  var NextActiveName = getTabName(index + 1);
  ActivingName.value = NextActiveName;

  // Internal Split Page Valid
  if (isInternalSplitTab()) {
    const bInternSplitLeave = InternSplitLeave();
    if (!bInternSplitLeave) {
      return;
    }
  }
  if (!await MinMaxDateMessage()) {
    return false;
  } 
  const bResult = await changeAction().then((res) => res);
  if (bResult) {
    bBeforeLeave.value = false; // 点击Next会执行离开前一个Tab验证,设置为取消验证
    activeName.value = NextActiveName;

    if ((route.query.ContractNo || '') === '') {
      RefreshPage();
      return;
    }
  }
};
const toEdit = () => {
  const message =
    useContract.getContractFunctionPermission('Edit')?.disableMessage;

  if (message) {
    //EnableEditMessage.value
    ElMessage({
      message,
      type: 'warning',
    });
    return;
  }

  if (isInternalSplitTab()) {
    const bInternSplitLeave = InternSplitLeave();
    if (!bInternSplitLeave) {
      return;
    }
  }

  OperationDisabled.value = false;
  if (!isOperationInstructionsTab()) {
    changeMode('edit');
  }

  changeButtonStatus(getActiveIndex(activeName.value));
};
const toSave = async () => {
  // Internal Split Page Valid
  if (isInternalSplitTab()) {
    const bInternSplitLeave = InternSplitLeave();
    if (!bInternSplitLeave) {
      return;
    }
  }
  if (!await MinMaxDateMessage()) {
    return false;
  } 
  var bResult = await SaveEvent().then((res) => res);
  if (bResult) {
    // Payment Schedule 特殊处理
    isPaymentLoading.value = false;

    if (useContract.Status === 'Open') {
      changeMode('view');
    }

    var index = getActiveIndex(activeName.value);
    if (index === getActiveIndex('Operation')) {
      OperationDisabled.value = true;
    }

    ElMessage({
      message: messageConfig.getMessage('savesuccess'),
      type: 'success',
    });

    await useContract.Init(ActivingName.value);
    if ((route.query.ContractNo || '') === '') {
      RefreshPage();
    }

    changeButtonStatus(index);
  }
};
const HandlerClick = async (buttonName) => {
  var index = getActiveIndex(activeName.value);

  var MessageAction = 'OK';

  var PageLockAction =
    index === getActiveIndex('DraftContract') &&
    contractDraftRef.value.getPageLock();

  if (buttonName === 'Back' || buttonName === 'Close') {
    if (isInternalSplitTab()) {
      const bInternSplitLeave = InternSplitLeave();
      if (!bInternSplitLeave) {
        return;
      }
    }

    var isSkipDiscard =
      isMediaItemsTab() && useMediaItems.OrderMediaItems.length === 0;

    if (
      ((!useContract.disabled && index !== getActiveIndex('Operation')) ||
        (index === getActiveIndex('Operation') && !OperationDisabled.value) ||
        PageLockAction) &&
      !isSkipDiscard
    ) {
      const DiscardMessageBox =
        require('@/components/discardMessage/discardMessage').default;
      MessageAction = await DiscardMessageBox({
        message: 'Do you want to save or discard this page?',
        title: 'Discard ' + TabNames[getActiveIndex(activeName.value)].label,
        distinguishCancelAndClose: true,
        confirmButtonText: 'Save',
        cancelButtonText: 'Discard',
        closeButtonText: 'Cancel',
      })
        .then(() => {
          return 'save';
        })
        .catch((action) => {
          return action;
        });
    }
  }

  if (MessageAction === 'close') {
    return;
  }

  if (MessageAction === 'save') {
    var action = PageLockAction ? 'PageLock' : undefined;
    if (!await MinMaxDateMessage()) {
      return false;
    } 
    const bNext = await SaveEvent(action).then((res) => res);
    if (!bNext) {
      return;
    }

    ElMessage({
      message: messageConfig.getMessage('savesuccess'),
      type: 'success',
    });
  }

  if (buttonName === 'Close') {
    useContract.OrderId = 0;
    useContract.Id = 0;
    // useContract.mode = 'view';

    location.href = '/order?OrderNo=' + useContract.ContractSummary.orderNumber;
    // router.push({
    //   name: 'order',
    //   query: {
    //     OrderNo: useContract.ContractSummary.orderNumber,
    //   },
    // });
  }

  if (buttonName === 'Back') {
    if (index > 0) {
      bBeforeLeave.value = false; // 禁用Tab BeforeLeave验证
      index = index - 1;
      if (isInternalSplitTab()) {
        var bLeave = InternSplitLeave();
        if (!bLeave) {
          return;
        }
      }

      activeName.value = getTabName(index);
      await useContract.getContractBase(useContract.cId, '', activeName.value);
    }
  }

  changeButtonStatus(index);
};
//检查最小最大日期
const MinMaxDateMessage = async() => {
  console.log('MinMaxDateMessage',activeName.value);
  if (activeName.value === 'InternalSplit') {
    if (!await useInternalSplitStore().MinMaxDateInternalSplit()) {
      ElMessage({ message: 'Please double check the campaign period in internal split', type: 'warning' });
      return false;
    }
  }
  if (activeName.value === 'Payment' ) {
    if (!await useInternalSplitStore().MinMaxDateInternalSplit()) {
      ElMessage({ message: 'Please double check the campaign period in internal split and payment schedule', type: 'warning' });
      return false;
    }
    if (!usePaymentScheduleStore().MinMaxDatePaymentSchedule()) {
      ElMessage({ message: 'Please double check the campaign period in payment schedule', type: 'warning' });
      return false;
    }
  }
  if (activeName.value === 'DraftContract') {
    if (!await useInternalSplitStore().MinMaxDateInternalSplit()) {
      ElMessage({ message: 'Please double check the campaign period in internal split and payment schedule', type: 'warning' });
      return false;
    }
    if (!useContractDraftStore().MinMaxDatePaymentSchedule()) {
      ElMessage({ message: 'Please double check the campaign period in payment schedule', type: 'warning' });
      return false;
    }
  }
  return true;
};
const SaveEvent = async (Action) => {
  var message = '';

  if (
    !useContract.disabled ||
    (getActiveIndex(activeName.value) === getActiveIndex('Operation') &&
      !OperationDisabled.value) ||
    Action === 'PageLock'
  ) {
    const store_name =
      TabNames.find((t) => t.name === activeName.value)?.store || '';
    if (store_name !== '') {
      const storeRequire = require(`@/store/${store_name}`);

      const storeModules = Object.values(storeRequire);

      if (storeModules) {
        const useStore = storeModules[0]();

        if (useStore.toSave) {
          message = await useStore.toSave(Action).then((msg) => msg);
        }

        if (store_name === 'mediaItem' && !message) {
          if (useStore.isMediaChanged || false) {
            await ElMessageBox.alert(useStore.MediaChangedMessage, 'Message', {
              confirmButtonText: 'OK',
            });
            useStore.isMediaChaged = false;
          }
        }
      }
    }

    // Payment Schedule手动设置刷新
    if (
      getActiveIndex(activeName.value) === getActiveIndex('Payment') &&
      message === ''
    ) {
      isPaymentLoading.value = true;
    }
  }

  if (message !== '') {
    ElMessage({
      message,
      type: 'warning',
    });
    return false;
  }

  if (
    ActivingName.value &&
    getActiveIndex(ActivingName.value) == getActiveIndex('DraftContract')
  ) {
    await useContract.getContractBase(useContract.cId, '', activeName.value);

    if (useContract.bEnterDraftContract) {
      await useContract.Init(ActivingName.value);
    }
  } else {
    await useContract.Init(ActivingName.value);
  }

  return message === '';
};

// Event: 点击Submit
const toSubmit = async () => {
  if (!await MinMaxDateMessage()) {
    return false;
  } 

  // //保存 BillingAddress按钮是否激活
  if (
    useContractDraft.ContractDrafts[0].clientAccountContact_Save == true ||
    (useContractDraft.ContractDrafts[1] &&
      useContractDraft.ContractDrafts[1].clientAccountContact_Save == true)
  ) {
    ElMessage({
      message: 'Please complete previous steps first',
      type: 'warning',
    });
    return false;
  }
  //保存 Combined Contract Required按钮是否激活
  if (
    useContractDraft.ContractDrafts[0].combinedContractRequired_Save == true
  ) {
    ElMessage({
      message: 'Please complete previous steps first',
      type: 'warning',
    });
    return false;
  }
  var UrgentMessage = undefined;

  var message =
    useContract.getContractFunctionPermission('SubmitContract')?.disableMessage;
  if (message) {
    ElMessage({
      message,
      type: 'warning',
    });
    return;
  }

  UrgentMessage = h(
    baseCheckbox,
    {
      modelValue: isUrgent.value,
      'onUpdate:modelValue': (val) => {
        isUrgent.value = val;
      },
    },
    'Urgent'
  );
  if (
    ContractSummary.value.isITC &&
    !useContractInfo.ContractBooking.intercomContractNumber
  ) {
    ElMessage({
      message: 'Please fill in Intercom Contract No in Contract Info tab.',
      type: 'warning',
    });
    return false;
  }

  var confirmMessage = h('p', null, [
    h('div', null, 'Are you sure you want to submit the contract(s)?'),
    UrgentMessage,
  ]);
  if (!useContract.disabled) {
    confirmMessage = h('p', null, [
      h(
        'div',
        null,
        'Draft contracts are automatically saved in editing when submitted.'
      ),
      h('div', null, ' Are you sure you want to submit the contract?'),
      UrgentMessage,
    ]);
  }

  ElMessageBox.confirm(confirmMessage, 'Submit Contract', {
    confirmButtonText: 'Confirm',
    cancelButtonText: 'Cancel',
    customClass: 'matrix-message-box',
    confirmButtonClass: 'right-confirm-1',
  }).then(async () => {
    if (!useContract.disabled) {
      const bSave = await SaveEvent().then((res) => res);
      if (!bSave) {
        return;
      }
    }

    var SubmitParams = {
      ContractId: useContract.Id,
      Unit: useContract.Unit,
      contract_id: useContract.cId,
    };
    if ((UrgentMessage || null) !== null) {
      SubmitParams.isUrgent = isUrgent.value;
    }

    const submit_res = await contractnet
      .submitContract(SubmitParams)
      .then((res) => res.data);

    if (submit_res !== '') {
      ElMessage({
        message: submit_res,
        type: 'warning',
      });
      return;
    }

    ElMessage({
      message: 'Submit success',
      type: 'success',
    });

    // 更新页面状态
    changeMode('view');

    await useContract.Init();
    await RefreshData(getActiveIndex('DraftContract'));
    changeButtonStatus(getActiveIndex('DraftContract'));
  });
};

const toSubmitJob = async () => {
  // //保存 BillingAddress按钮是否激活
  var disableMessage = useContract.getContractFunctionPermission(
    'SubmitSignedContract'
  )?.disabledMessage;
  if (disableMessage) {
    ElMessage({
      message: disableMessage,
      type: 'warning',
    });
    return false;
  }
  //保存 Combined Contract Required按钮是否激活
  if (
    useContractDraft.ContractDrafts[0].combinedContractRequired_Save == true
  ) {
    ElMessage({
      message: 'Please complete previous steps first',
      type: 'warning',
    });
    return false;
  }

  if (
    useContract.Status === 'Issued' &&
    useContractInfo.Contract.signed === 'Open' &&
    useContractDraft.ContractDrafts.filter(
      (t) => JSON.parse(t.signedContractFile || '[]').length === 0
    ).length > 0
  ) {
    ElMessage({
      message: 'Please upload "Signed Contract" before submit.',
      type: 'warning',
    });
    return false;
  }
  // var draft = useContractDraft.ContractDrafts.find(
  //   (t) => t.action != 'production'
  // );
  // if (draft && draft.discountRate > 80) {
  //   var files = JSON.parse(draft.approvalDocumentFile || '[]');
  //   if (files == '[]' || files.length < 1) {
  //     ElMessage({
  //       message:
  //         'Discount Rate exceeds 80%, please upload approval documents before submitting the contract.',
  //       type: 'warning',
  //     });
  //     return false;
  //   }
  // }
  //验证如果是ITC,intercomContractNumber不能为空
  if (
    ContractSummary.value.isITC &&
    !useContractInfo.ContractBooking.intercomContractNumber
  ) {
    ElMessage({
      message: 'Please fill in Intercom Contract No in Contract Info tab.',
      type: 'warning',
    });
    return false;
  }
  ElMessageBox.confirm(
    'Are you sure you want to submit the contract(s)?',
    'Submit Contract',
    {
      confirmButtonText: 'Confirm',
      cancelButtonText: 'Cancel',
      customClass: 'matrix-message-box',
      confirmButtonClass: 'right-confirm-1',
    }
  ).then(async () => {
    if (!useContract.disabled) {
      const bSave = await SaveEvent().then((res) => res);
      if (!bSave) {
        return;
      }
    }

    var SubmitParams = {
      ContractId: useContract.Id,
      Unit: useContract.Unit,
      contract_id: useContract.cId,
    };

    const submit_res = await contractnet
      .submitJob(SubmitParams)
      .then((res) => res.data);

    if (submit_res !== '') {
      ElMessage({
        message: submit_res,
        type: 'warning',
      });
      return;
    }

    ElMessage({
      message: 'Submit success',
      type: 'success',
    });

    await useContract.Init();
    await RefreshData(getActiveIndex('DraftContract'));
    changeButtonStatus(getActiveIndex(activeName.value));
  });
};

// Event: 点击Revise
const toRevise = async () => {
  var reviseFunction = useContract.getContractFunctionPermission('Revise');
  //var message = useContract.EnableReviseMessage || useContract.ReviseMessage;
  var message = reviseFunction.disabledMessage || reviseFunction.alertMessage;
  if (message) {
    ElMessage({
      message,
      type: 'warning',
    });
    return;
  }

  const Action = await ElMessageBox.confirm(
    'Are you sure you want to revise this contract?',
    'Revise Contract',
    {
      confirmButtonText: 'Confirm',
      cancelButtonText: 'Cancel',
      customClass: 'matrix-message-box',
      confirmButtonClass: 'right-confirm-1',
    }
  ).then(() => {
    return 'confirm';
  });

  if ((Action || '') === 'confirm') {
    //是否存在Action发票
    if (useContractStore().otherData.existInvoice) {
      await ElMessageBox.alert('An invoice exists for this contract. Please contact the Finance Team if you need to void the invoice.', 'Message', {
        confirmButtonText: 'OK',
      })
        .then(() => { })
        .catch(() => { });
    }
    // 验证是14天内

    const revise_res = await contractnet
      .ReviseContract({
        contract_id: useContract.cId,
        Unit: useContract.Unit,
      })
      .then((res) => res.data);

    message = revise_res.resultMessage || '';
    if (message !== '') {
      ElMessage({
        message,
        type: 'warning',
      });
      return;
    }

    await useContract.Init();
    await RefreshData(getActiveIndex('DraftContract'));
    changeButtonStatus(getActiveIndex('DraftContract'));
  }
};

const toReviseUnlock = () => {
  const message =
    useContract.getContractFunctionPermission('ReviseUnlock')?.message;
  if (message) {
    ElMessage({
      message,
      type: 'warning',
    });
    return;
  }

  contractnet.ReviseUnlock(useContract.cId).then((res) => {
    if ((res.data.message || '') !== '') {
      ElMessage({
        message: res.data.message,
        type: 'warning',
      });
      return;
    }
    useContract.Init();
    RefreshData(getActiveIndex('DraftContract'));
  });
};

// 取消合同
const toCancel = () => {
  const message =
    useContract.getContractFunctionPermission('CancelContract').disableMessage;
  if (message) {
    ElMessage({
      message,
      type: 'warning',
    });
    return;
  }

  var ContractNumber;
  if (BusinessUnit.alias == 'BB') {
    ContractNumber = useContractDraft.ContractDrafts?.[0].contractNumber;
  }

  ElMessageBox.confirm(
    `Are you sure to cancel the contract (${ContractNumber})?`,
    'Cancel Contract',
    {
      confirmButtonText: 'Confirm',
      cancelButtonText: 'Cancel',
      customClass: 'matrix-message-box',
      confirmButtonClass: 'right-confirm-1',
    }
  ).then(async () => {
    var res = await contractnet
      .CancelContract(useContract.cId)
      .then((res) => res.data);
    if (res?.message) {
      ElMessage({
        message: res.message,
        type: 'warning',
      });
    } else {
      ElMessage({
        message: 'Cancel success.',
        type: 'success',
      });

      await useContract.Init();
      await RefreshData(getActiveIndex('DraftContract'));
      changeButtonStatus(getActiveIndex('DraftContract'));
    }
  });
};

// 作废合同
const toVoid = async () => {
  VoidComment.value = '';

  var permission = useContract.getContractFunctionPermission('VoidContract');
  if (permission.alertMessage) {
    ElMessageBox.alert(permission.alertMessage);
  } else {
    var ContractNumber;
    if (BusinessUnit.alias == 'BB') {
      ContractNumber = useContractDraft.ContractDrafts?.[0].contractNumber;
    }

    var propMessage = h('p', null, [
      h(
        'div',
        {
          style: 'padding-bottom:18px;',
        },
        `Are you sure to void the contract (${ContractNumber})?`
      ),
      h('div', null, [
        h('span', null, 'Remark'),
        h('span', { style: 'color:red' }, '*'),
      ]),
      h(baseInput, {
        modelValue: VoidComment.value,
        'onUpdate:modelValue': (val) => {
          VoidComment.value = val;
        },
      }),
    ]);

    await ElMessageBox({
      title: 'Void Contract',
      message: propMessage,
      showCancelButton: true,
      confirmButtonText: 'Confirm',
      cancelButtonText: 'Cancel',
      customClass: 'matrix-message-box',
      confirmButtonClass: 'right-confirm-1',
      beforeClose: (action, instance, done) => {
        if (action == 'confirm') {
          if (!VoidComment.value) {
            if (instance.customClass.indexOf('is-error') == -1) {
              instance.customClass = instance.customClass + ' is-error';
            }
            instance.message.children[2].component.props.error =
              'Please fill in mandatory!';
          } else {
            instance.customClass = instance.customClass.replace(
              ' is-error',
              ''
            );
            instance.message.children[2].component.props.error = '';

            done();
          }
        } else {
          done();
        }
      },
    }).then(async (action) => {
      const void_res = await contractnet
        .VoidContract(useContract.cId, VoidComment.value)
        .then((res) => res.data);

      if (void_res?.message) {
        ElMessage({
          message: void_res.message,
          type: 'warning',
        });
        return;
      }

      ElMessage({
        message: 'Void success.',
        type: 'success',
      });
      await useContract.Init();
      await RefreshData(getActiveIndex('DraftContract'));
      changeButtonStatus(getActiveIndex('DraftContract'));
    });
  }
};

// 弹出审批界面
const toApprove = () => {
  const message =
    useContract.getContractFunctionPermission(APPROVE_FUNCTION).disableMessage;
  if (message) {
    ElMessage({
      message,
      type: 'warning',
    });
    return;
  }

  ApproveComment.value = '';
  ApproveDialog.value = true;
};

// ApproveData实体
const NewApproveData = (flow_name, taskid, contract_id, contractId, action) => {
  var new_approvedata = {
    ApproveFlowName: 'CONTRACT_PROCESS_BB',
    ProcessFlowTaskId: taskid,
    ApproveAction: 'Approve',
    Contract_Id: contract_id,
    ContractId: contractId,
  };

  if (flow_name) {
    new_approvedata.ApproveFlowName = flow_name;
  }
  if (action) {
    new_approvedata.ApproveAction = action;
  }
  return new_approvedata;
};

// 审批合同
const ApproveContract = async (ApproveAction) => {
  if (ApproveAction === 'Reject' && !ApproveComment.value) {
    ElMessage({
      message: 'Please fill in the Comment',
      type: 'warning',
    });
    return;
  }

  ApproveDialog.value = false;

  const useContract = useContractStore();

  // 当前流程信息
  var task_flow = useContract.getTaskFlow();

  var approve_data = NewApproveData(
    task_flow.process_flow_name,
    task_flow.processFlowTaskId,
    useContract.getCId(),
    useContract.Id,
    ApproveAction
  );
  approve_data.ApproveComment = ApproveComment.value;

  var requestData = {
    Unit: useContract.Unit.alias,
    OrderId: useContract.getOrderId(),
    ApproveDatas: [approve_data],
  };
  // ApproveModel.ApproveAction = ApproveAction;
  // ApproveModel.OrderId = useContract.OrderId;
  // ApproveModel.ApproveDatas = [approve_data];
  // ApproveModel.ContractIds = [useContract.Id];
  // ApproveModel.ProcessFlowTaskIds = [useContract.TaskFlow.processFlowTaskId];
  // if (useContract.Status === 'Issued') {
  //   ApproveModel.ApproveFlowName = 'JOB_PROCESS_BB';
  // }

  //提交审批
  const message = await useContract
    .approveContract(requestData)
    .then((res) => res);
  if (message !== '') {
    ElMessage({
      message,
      type: 'warning',
    });
    return;
  }

  //重置Approve
  // ApproveModel.ApproveAction = '';
  // ApproveModel.ContractIds = [];
  // ApproveModel.ProcessFlowTaskIds = [];
  // ApproveModel.ApproveComment = '';

  window.location.href = location.href;
};

const changeButtonStatus = (index) => {
  const useAuthority = useAuthorityStore();

  isBackButton.value = index > getActiveIndex('ContractInfo');
  isVoidButton.value = index === getActiveIndex('DraftContract');
  bVoidDisabled.value =
    useContract.Status !== 'Open' && !useAuthority.isOrderTop();
  isEditButton.value =
    (useContract.disabled &&
      ![
        getActiveIndex('DraftContract'),
        getActiveIndex('Operation'),
        getActiveIndex('AdditionalInfo'),
      ].includes(index)) ||
    (OperationDisabled.value && index === getActiveIndex('Operation'));
  bEditDiabled.value =
    useContract.getContractFunctionPermission('Edit')?.disable;
  isSaveButton.value =
    !isEditButton.value &&
    ![
      getActiveIndex('DraftContract'),
      getActiveIndex('AdditionalInfo'),
    ].includes(index);

  var submitFunction =
    useContract.getContractFunctionPermission('SubmitContract');
  // isSubmitButton.value =
  //   index === getActiveIndex('DraftContract') &&
  //   useContract.Status != 'Issued' &&
  //   ((useContract.TaskFlow.processFlowStatus || 'Submit') === 'Submit' ||
  //     (useContract.TaskFlow.processFlowStatus || 'Submit') == 'Completed');
  isSubmitButton.value = submitFunction?.enable;

  var submitJobFunction = useContract.getContractFunctionPermission(
    'SubmitSignedContract'
  );
  // isSubmitJobButton.value =
  //   useContract.getFunctionPermission('Submit Signed Contract')?.enable &&
  //   !useContract.getFunctionPermission('Submit Signed Contract')?.disable;
  isSubmitJobButton.value = submitJobFunction?.enable;

  // bSubmitDisabled.value = !useContract.bEnableSubmit;
  bSubmitDisabled.value = submitFunction?.disable;
  bSubmitJobDisabled.value = submitJobFunction?.disable;

  var reviseFunction = useContract.getContractFunctionPermission('Revise');
  //isReviseButton.value = index === getActiveIndex('DraftContract');
  isReviseButton.value = reviseFunction.enable;
  //bReviseDisabled.value = !useContract.bEnableRevise;
  bReviseDisabled.value = reviseFunction.disable;
  isNextButton.value =
    index !== getActiveIndex(TabNames[TabNames.length - 1].name);
  isApproveButton.value =
    index === getActiveIndex('DraftContract') && useContract.bEnableApprove;

  bApproveDisabled.value =
    index !== getActiveIndex('DraftContract') || !useContract.bEnableApprove;
};
// Event: 点击Next或者Draft Contract
const ChangeDraftContract = async () => {
  await contractnet.RegenerateDraftContract(useContract.Id);
};

// 进入Draft Contract前验证
const contractDraftEnter = () => {
  if (!useContract.bEnterDraftContract) {
    const messageConfig = require('@/models/messageConfig');

    ElMessage({
      message: messageConfig.getMessage('draftvalid1'),
      type: 'warning',
    });

    const tabIndex = getActiveIndex(activeName.value);

    if (tabIndex === getActiveIndex('DraftContract') || tabIndex < 0) {
      activeName.value = 'ContractInfo';
      changeButtonStatus(0);
    }
    return false;
  }
  return true;
};

const InternSplitLeave = () => {
  var ProductionCostSplitRef = InternSplitRef.value.ProductionCostSplitRef;
  var SpecialCommissionArragementRef =
    InternSplitRef.value.SpecialCommissionArragementRef;
  if (
    ProductionCostSplitRef.isActive() ||
    SpecialCommissionArragementRef.isActive()
  ) {
    if (!useContract.disabled) {
      ElMessage({
        message: 'Please complete previous steps first',
        type: 'warning',
      });
      return false;
    }

    if (ProductionCostSplitRef.isActive()) {
      ProductionCostSplitRef.close();
    }

    if (SpecialCommissionArragementRef.isActive()) {
      SpecialCommissionArragementRef.close();
    }
  }
  return true;
};

//#endregion
</script>
<style scope>
.new-order h4 {
  color: #3b291d;
}

.new-order h5 {
  color: #423022;
}

.sales-title h4.sub {
  margin-left: 54px;
  display: inline-block;
  font-size: 11px;
}

.sales-title i {
  position: relative;
  top: -1px;
  right: 4px;
}

.new-order .el-descriptions :not(.is-bordered) .el-descriptions-item__cell {
  padding-bottom: 6px;
}

/* .advertiser-field .form-group.has-label label::after{
    content:'【 Contracting Party 】';
    color:#d05c5f;
} */
.sub-info {
  font-size: 10px;
  color: #9a9a9a;
  margin-left: 30px;
}

.sub-info .dot {
  width: 5px;
  height: 5px;
  background-color: rgb(169, 169, 169);
  display: inline-block;
  border-radius: 50%;
  top: -1px;
  position: relative;
  right: 2px;
}

.newRow {
  padding-bottom: 25px;
  padding-top: 25px;
}

.Rectangle {
  width: 130px;
  height: 32px;
  text-align: center;
  border-radius: 6px;
  border: solid 1px #543d2c;
}

.newCard {
  padding: 7px 11px 11.5px;
  border-radius: 6px;
  border: solid 1px #543d2c;
  margin-bottom: 25px;
}

.newCardNoPadding {
  border-radius: 6px;
  border: solid 1px #543d2c;
  margin-bottom: 25px;
  padding-bottom: 10px;
}

.newText {
  opacity: 0.8;
  font-family: Poppins;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 0.93;
  letter-spacing: normal;
  text-align: left;
  color: #423022;
}

.groupButtonOutdoor {
  border: solid 1px var(--primary);
  width: 107px;
  height: 38px;
  line-height: 38px;
  background: var(--primary);
  text-align: center;
  color: #fff;
}

.groupButtonBus {
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
}

.groupButtonBus,
.groupButtonMtr {
  border: solid 1px var(--primary);
  width: 107px;
  height: 38px;
  line-height: 38px;
  text-align: center;
  color: var(--primary);
}

.groupButtonMtr {
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
}

.el-date-editor {
  border-radius: 10px;
  border: solid 1px #543d2c;
}

.RectangleNoWidth {
  line-height: 38px;
  height: 38px;
  text-align: left;
  border-radius: 6px;
  border: solid 1px #e3e3e3;
  background-color: #f5f5f5;
}

.tableRectangle {
  border: solid 1px #e3e3e3;
  padding: 10px;
  height: 90px;
}

table.internal-split {
  width: 100%;
}

table.internal-split td {
  border: 1px solid #e3e3e3;
  padding: 10px 15px;
}

.el-date-editor {
  margin-top: 0px !important;
}

.el-message-box p {
  color: var(--el-text-color-primary);
}

.el-table table .form-check {
  margin: 0;
  margin-top: 18px !important;
}

.btn.btn-Void,
.btn.btn-Void:hover,
.btn.btn-Void:focus,
.btn.btn-Void:disabled {
  min-width: 130px;
  background: linear-gradient(255deg, #ff8d72, #ff6491) !important;
}

.matrix-message-box,
.base-message-box {
  min-width: 560px;
}

.matrix-message-box .el-message-box__btns {
  display: block;
}

.matrix-message-box .el-button {
  float: right;
  margin-right: 5px;
}

.base-message-box .discard,
.base-message-box .discard:hover,
.base-message-box .discard:focus {
  border-color: #e56825;
  background: #e56825 !important;
  color: #fff;
}

.base-message-box .el-message-box__btns {
  display: none;
}

.base-message-box .base-message-box__btns {
  padding: 5px 15px 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  align-items: center;
  column-gap: 5px;
}

.base-message-box.el-message-box__center {
  padding-left: calc(var(--el-messagebox-padding-primary) + 12px);
  padding-right: calc(var(--el-messagebox-padding-primary) + 12px);
  text-align: center;
}

.base-message-box .el-message-box__content {
  padding: 0px !important;
}

.base-message-box .base-message-box__content {
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: calc(var(--el-messagebox-padding-primary) + 12px);
  padding-right: calc(var(--el-messagebox-padding-primary) + 12px);
}

.base-message-box .el-button {
  width: 130px;
}

.date {
  border: 0px !important;
}
</style>
